import { simulatorBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getSimulations = async prospectId => {
  const response = await simulatorBackend.get(`/simulations/${prospectId}`, getOptions());
  return response.data;
};

export const getLatestSimulation = async (prospectId, token = null) => {
  let options = {};
  if (token) {
    options = { Authorization: `Bearer ${token}` };
  }
  const response = await simulatorBackend.get(`/simulations/latest/${prospectId}`, options);
  return response.data;
};
